// apps/web/src/offline/OfflineGameService.js

import {
  STORES,
  dbGet,
  dbGetByIndex,
  dbPut,
} from './db'

// ======================================================
// PREPARAR SNAPSHOT DO JOGO
// ======================================================

const prepareGameSnapshot = (
  game,
) => {
  if (!game?.id) {
    throw new Error(
      'Jogo inválido para armazenamento offline',
    )
  }

  return {
    ...game,

    offlineUpdatedAt:
      new Date().toISOString(),

    offlineSnapshotVersion:
      1,
  }
}

// ======================================================
// JOGO
// ======================================================

const saveGame = async (
  game,
) => {
  const snapshot =
    prepareGameSnapshot(
      game,
    )

  await dbPut(
    STORES.GAMES,
    snapshot,
  )

  if (
    Array.isArray(
      game.prizes,
    )
  ) {
    await dbPut(
      STORES.PRIZES,
      {
        gameId:
          game.id,

        prizes:
          game.prizes,

        offlineUpdatedAt:
          new Date()
            .toISOString(),
      },
    )
  }

  return snapshot
}

const getGameById = async (
  gameId,
) => {
  return dbGet(
    STORES.GAMES,
    gameId,
  )
}

const getGameBySlug = async (
  slug,
) => {
  return dbGetByIndex(
    STORES.GAMES,
    'slug',
    slug,
  )
}

// ======================================================
// FORMULÁRIO
// ======================================================

const saveLeadForm = async (
  gameId,
  leadForm,
) => {
  if (!gameId) {
    return null
  }

  return dbPut(
    STORES.LEAD_FORMS,
    {
      gameId,

      data:
        leadForm ||
        null,

      offlineUpdatedAt:
        new Date()
          .toISOString(),
    },
  )
}

const getLeadForm = async (
  gameId,
) => {
  const record =
    await dbGet(
      STORES.LEAD_FORMS,
      gameId,
    )

  return record?.data ||
    null
}

// ======================================================
// PRÊMIOS
// ======================================================

const getPrizes = async (
  gameId,
) => {
  const record =
    await dbGet(
      STORES.PRIZES,
      gameId,
    )

  return record?.prizes ||
    []
}

// ======================================================
// META
// ======================================================

const saveMeta = async (
  key,
  value,
) => {
  return dbPut(
    STORES.META,
    {
      key,

      value,

      updatedAt:
        new Date()
          .toISOString(),
    },
  )
}

const getMeta = async (
  key,
) => {
  const record =
    await dbGet(
      STORES.META,
      key,
    )

  return record?.value ??
    null
}

// ======================================================
// JOGO DA MEMÓRIA
// ======================================================

const saveMemoryConfig =
  async (
    gameId,
    memoryData,
  ) => {
    if (
      !gameId
    ) {
      throw new Error(
        'gameId não informado para salvar jogo da memória offline',
      )
    }

    if (
      !memoryData
    ) {
      throw new Error(
        'Configuração do jogo da memória não informada',
      )
    }

    const snapshot = {
      ...memoryData,

      offlineUpdatedAt:
        new Date()
          .toISOString(),

      offlineSnapshotVersion:
        1,
    }

    await saveMeta(
      `memory:${gameId}:config`,
      snapshot,
    )

    return snapshot
  }

const getMemoryConfig =
  async (
    gameId,
  ) => {
    if (
      !gameId
    ) {
      return null
    }

    return getMeta(
      `memory:${gameId}:config`,
    )
  }

// ======================================================
// VERIFICAR SE MEMÓRIA ESTÁ PREPARADA
// ======================================================

const hasMemoryConfig =
  async (
    gameId,
  ) => {
    const config =
      await getMemoryConfig(
        gameId,
      )

    return Boolean(
      config,
    )
  }

  // ======================================================
// QUIZ
// ======================================================

const saveQuizConfig =
  async (
    gameId,
    quizData,
  ) => {
    if (!gameId) {
      throw new Error(
        'gameId não informado para salvar Quiz offline',
      )
    }

    if (!quizData) {
      throw new Error(
        'Configuração do Quiz não informada',
      )
    }

    const snapshot = {
      ...quizData,

      offlineUpdatedAt:
        new Date()
          .toISOString(),

      offlineSnapshotVersion:
        1,
    }

    await saveMeta(
      `quiz:${gameId}:config`,
      snapshot,
    )

    console.log(
      '[OFFLINE QUIZ] Configuração salva:',
      gameId,
    )

    return snapshot
  }

const getQuizConfig =
  async (
    gameId,
  ) => {
    if (!gameId) {
      return null
    }

    return getMeta(
      `quiz:${gameId}:config`,
    )
  }

const hasQuizConfig =
  async (
    gameId,
  ) => {
    const config =
      await getQuizConfig(
        gameId,
      )

    return Boolean(
      config,
    )
  }

// ======================================================
// EXPORT
// ======================================================

const OfflineGameService = {
  // Jogo
  saveGame,
  getGameById,
  getGameBySlug,

  // Formulário
  saveLeadForm,
  getLeadForm,

  // Prêmios
  getPrizes,

  // Jogo da memória
  saveMemoryConfig,
  getMemoryConfig,
  hasMemoryConfig,

  // Quiz
  saveQuizConfig,
  getQuizConfig,
  hasQuizConfig,

  // Meta
  saveMeta,
  getMeta,
}

export default OfflineGameService